// This component is essentially just styles with no functionality, so safe to
// ignore for coverage
/* istanbul ignore file */

import { applyOpacity } from "../../styles/utils";
import { media } from "../../styles";
import React from "react";
import styled from "styled-components";
export type RadioProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type">;
const Input = styled.input.attrs({
  type: "radio"
})`
  // Disable default radio button
  appearance: none;
  -webkit-appearance: none;
  position: relative;

  height: 1.25rem;
  width: 1.25rem;

  border: 2px solid ${({
  theme
}) => theme.brand.cssVars["--d-border"]};
  border-radius: 50%;

  // Checked dot
  &:checked {
    border-color: ${({
  theme
}) => theme.brand.cssVars["--d-primary"]};

    &::after {
      content: "";
      position: absolute;
      left: 0.25rem;
      top: 0.25rem;

      height: 0.625rem;
      width: 0.625rem;
      background: ${({
  theme
}) => theme.brand.cssVars["--d-primary"]};
      border-radius: 50%;
    }
  }

  @media ${media.hoverable} {
    &:hover {
      cursor: pointer;
    }
  }

  &:focus {
    outline: none;
    background-color: ${({
  theme
}) => applyOpacity(theme.brand.cssVars["--d-text"], 0.1, true, theme.brand.cssVars["--d-surface"])};
  }
`;
export function Radio(props: RadioProps) {
  return <Input {...props} data-sentry-element="Input" data-sentry-component="Radio" data-sentry-source-file="Radio.tsx" />;
}
export default Radio;